import { render, staticRenderFns } from "./MapOt_Bhis.vue?vue&type=template&id=f1bf6756&"
import script from "./MapOt_Bhis.vue?vue&type=script&lang=js&"
export * from "./MapOt_Bhis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports